module.exports = __webpack_public_path__ + "static/velvetzoo-og-image-09834137519c294313ff3ab2805feff1.jpg";